import { Record } from "../fable_modules/fable-library.3.7.20/Types.js";
import { initState, reducer, ModalsAction$reflection } from "./Reducers/ModalsReducer.js";
import { record_type, lambda_type, anonRecord_type, string_type, option_type, list_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { initState as initState_1, reducer as reducer_1, ModelAction$reflection, ModelState$reflection } from "./Reducers/ModelReducer.js";
import { initState as initState_2, reducer as reducer_2, TelecomAction$reflection, TelecomState$reflection } from "./Reducers/TelecomReducer.js";
import { initState as initState_3, reducer as reducer_3, InvoiceeAction$reflection, InvoiceeState$reflection } from "./Reducers/InvoiceeReducer.js";
import { initState as initState_4, reducer as reducer_4, ContractAction$reflection, ContractState$reflection } from "./Reducers/ContractReducer.js";
import { initState as initState_5, reducer as reducer_5, DirectInvoiceAction$reflection, DirectInvoiceState$reflection } from "./Reducers/DirectInvoiceReducer.js";
import { thunk, applyMiddleware, composeEnhancers, createStore, combineReducers } from "./Redux.js";
import { useDispatch as useDispatch_1, useSelector as useSelector_1 } from "react-redux";

class AllReducers extends Record {
    constructor(Modals, Model, Telecom, Invoicee, Contract, DirectInvoice) {
        super();
        this.Modals = Modals;
        this.Model = Model;
        this.Telecom = Telecom;
        this.Invoicee = Invoicee;
        this.Contract = Contract;
        this.DirectInvoice = DirectInvoice;
    }
}

function AllReducers$reflection() {
    return record_type("Redux.Store.AllReducers", [], AllReducers, () => [["Modals", lambda_type(option_type(list_type(ModalsAction$reflection())), lambda_type(anonRecord_type(["Value", ModalsAction$reflection()], ["type", string_type]), list_type(ModalsAction$reflection())))], ["Model", lambda_type(option_type(ModelState$reflection()), lambda_type(anonRecord_type(["Value", ModelAction$reflection()], ["type", string_type]), ModelState$reflection()))], ["Telecom", lambda_type(option_type(TelecomState$reflection()), lambda_type(anonRecord_type(["Value", TelecomAction$reflection()], ["type", string_type]), TelecomState$reflection()))], ["Invoicee", lambda_type(option_type(InvoiceeState$reflection()), lambda_type(anonRecord_type(["Value", InvoiceeAction$reflection()], ["type", string_type]), InvoiceeState$reflection()))], ["Contract", lambda_type(option_type(ContractState$reflection()), lambda_type(anonRecord_type(["Value", ContractAction$reflection()], ["type", string_type]), ContractState$reflection()))], ["DirectInvoice", lambda_type(option_type(DirectInvoiceState$reflection()), lambda_type(anonRecord_type(["Value", DirectInvoiceAction$reflection()], ["type", string_type]), DirectInvoiceState$reflection()))]]);
}

export class AppState extends Record {
    constructor(Modals, Model, Telecom, Invoicee, Contract, DirectInvoice) {
        super();
        this.Modals = Modals;
        this.Model = Model;
        this.Telecom = Telecom;
        this.Invoicee = Invoicee;
        this.Contract = Contract;
        this.DirectInvoice = DirectInvoice;
    }
}

export function AppState$reflection() {
    return record_type("Redux.Store.AppState", [], AppState, () => [["Modals", list_type(ModalsAction$reflection())], ["Model", ModelState$reflection()], ["Telecom", TelecomState$reflection()], ["Invoicee", InvoiceeState$reflection()], ["Contract", ContractState$reflection()], ["DirectInvoice", DirectInvoiceState$reflection()]]);
}

const allReducersObj = new AllReducers(reducer, reducer_1, reducer_2, reducer_3, reducer_4, reducer_5);

const initialAppState = (() => {
    const o = new AppState(initState, initState_1, initState_2, initState_3, initState_4, initState_5);
    return Object.assign({}, o);
})();

const rootReducer = combineReducers(allReducersObj);

export const reduxStore = createStore(rootReducer, initialAppState, composeEnhancers(applyMiddleware(thunk)));

export const useSelector = useSelector_1;

export const useDispatch = useDispatch_1;

